import { render } from "./InsuranceCalculationLife.vue?vue&type=template&id=4ba6b898&scoped=true&lang=pug"
import script from "./InsuranceCalculationLife.vue?vue&type=script&lang=js"
export * from "./InsuranceCalculationLife.vue?vue&type=script&lang=js"

import "./InsuranceCalculationLife.vue?vue&type=style&index=0&id=4ba6b898&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba6b898"]])

export default __exports__